<template>
  <div id="hero" class="hero-wrap style6 bg-albastor">
    <img
      src="../../assets/images/hero/hero-shape-2.png"
      alt="Image"
      class="hero-shape-two bounce"
    />
    <div class="container">
      <img
        src="../../assets/images/hero/hero-shape-1.png"
        alt="Image"
        class="hero-shape-one"
      />
      <img
        src="../../assets/images/hero/hero-shape-3.png"
        alt="Image"
        class="hero-shape-three"
      />
      <img
        src="../../assets/images/hero/hero-shape-4.png"
        alt="Image"
        class="hero-shape-four"
      />
      <div class="row gx-5 align-items-center">
        <div class="col-lg-6">
          <div class="hero-content" data-speed="0.10" data-revert="true">
            <span
              data-aos="fade-right"
              data-aos-duration="1200"
              data-aos-delay="200"
              >Consult Our Specialist</span
            >
            <h1
              data-aos="fade-right"
              data-aos-duration="1200"
              data-aos-delay="300"
            >
              We Provide The Best Cosmetic Surgery
            </h1>
            <p
              data-aos="fade-right"
              data-aos-duration="1200"
              data-aos-delay="400"
            >
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry.Lorem Ipsum has been the industry'sstandard dummy text
              ever since the 1500s, when an unknown printer took.
            </p>
            <div
              class="hero-btn"
              data-aos="fade-right"
              data-aos-duration="1200"
              data-aos-delay="500"
            >
              <a href="#appointment" class="btn style2">Book An Appointment</a>
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="hero-img-wrap">
            <img src="../../assets/images/hero/hero-img-3.png" alt="Image" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MainBanner",
};
</script>